import { render, staticRenderFns } from "./gridMenu.vue?vue&type=template&id=6695ef79&scoped=true"
import script from "./gridMenu.vue?vue&type=script&lang=js"
export * from "./gridMenu.vue?vue&type=script&lang=js"
import style0 from "./gridMenu.vue?vue&type=style&index=0&id=6695ef79&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6695ef79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6695ef79')) {
      api.createRecord('6695ef79', component.options)
    } else {
      api.reload('6695ef79', component.options)
    }
    module.hot.accept("./gridMenu.vue?vue&type=template&id=6695ef79&scoped=true", function () {
      api.rerender('6695ef79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/gridMenu.vue"
export default component.exports